import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import JSON translation files
import en from "./locales/en.json";
import hi from "./locales/hi.json";
import gu from "./locales/gu.json";
import kn from "./locales/kn.json";
import pa from "./locales/pa.json";
import te from "./locales/te.json";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      hi: { translation: hi },
      gu: { translation: gu },
      kn: { translation: kn },
      pa: { translation: pa },
      te: { translation: te },
    },
    lng: "en", // default language
    fallbackLng: "en",
    interpolation: { escapeValue: false },
  });

export default i18n;
